import {postUpdateStatus} from '../api/postUpdateStatus';
import { setGetSearchList } from './setGetSearchList';

const setPostUpdateStatus = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateStatus(params);  
            dispatch(setGetSearchList({
                search: '',
                page: 1,
                rowsPerPage: 25
            }))      
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateStatus
}